import React, { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux'
import Slider from '../slides/Slider';
import { getGroupPlaylists, getPlaylistGroups } from '../../actions/PlaylistActions'
import { useNavigate } from 'react-router-dom';

export default function PlaylistGroup(props) {

    const dispatch = useDispatch()

    const navigate = useNavigate()

    const playlistList = useSelector(state => state.groupPlaylists)
    const { error, groupPlaylists} = playlistList

    useEffect(() => {
        dispatch(getGroupPlaylists(props.activeGroup.id))
    },[dispatch, props.activeGroup])

    const viewAllHandler = () => {
        navigate(encodeURI(`/group/${props.activeGroup.id}/${props.activeGroup.title}`))
    }

  return (
      <div className='col-12 d-flex flex-column justify-content-center'>
          {
            error ? <h3>{error}</h3> :
            groupPlaylists && groupPlaylists.length ?
            <>
              <Slider
                    num = {5}
                    type = {1}
                    showTitle = {true}
                    tvData={groupPlaylists}
                    slideClickHandler={props.slideClickHandler}
                    slideTitle = {props.activeGroup.title}  
                    showAllHandler = {viewAllHandler}
                    
              />
            </> :""
          }
    </div>
  )
}

